'use strict';

/* globals config */

require([config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js'], function (Vue) {
	Vue.component('url-note', {
		props: ['note', 'saveNote', 'editMode'],
		data: function () {
			return {
				noteId: this.note.noteId,
				content: this.note.content,
			};
		},
		mounted: function () {

		},
		methods: {

		},
		template: '<div>' +
		'NOT AVAILABLE NOW' +
		'</div>',
	});
});
